export const InvoicePriceInfSONSchema = {
  type: 'object',
  properties: {
    totalGrossAmount: {
      type: 'string',
      description: 'OD',
    },
    totalTaxAmount: {
      type: 'string',
    },
    totalDiscountAmount: {
      type: 'string',
    },
    totalPromotionAmount: {
      type: 'string',
    },
    totalNetPrice: {
      type: 'string',
    },
    points: {
      type: 'string',
    },
  },
}

export const InvoicePriceInfSONUiSchema = {
  type: 'VerticalLayout',
  className: 'identification-filters',
  elements: [
    {
      type: 'HorizontalLayout',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/totalGrossAmount',
          component: 'ReadOnlyFieldWithJson',
          label: 'Total Gross Amount ',
        },
        {
          type: 'Control',
          scope: '#/properties/totalTaxAmount',
          component: 'ReadOnlyFieldWithJson',
          label: 'Total Tax Amount',
        },
        {
          type: 'Control',
          scope: '#/properties/totalDiscountAmount',
          component: 'ReadOnlyFieldWithJson',
          label: 'Total Discount Amount ',
        },
      ],
    },
    {
      type: 'HorizontalLayout',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/totalPromotionAmount',
          component: 'ReadOnlyFieldWithJson',
          label: 'Total Promotion Amount',
        },
        {
          type: 'Control',
          scope: '#/properties/totalNetPrice',
          component: 'ReadOnlyFieldWithJson',
          label: 'Total Net Price',
        },
        {
          type: 'Control',
          scope: '#/properties/points',
          component: 'ReadOnlyFieldWithJson',
          label: 'Points',
        },
      ],
    },
  ],
}
